/**
 * defa.views.SearchResultSnippet
 * A snippet for search-results.
 * @version 1.2.1
 */
import Snippet from 'scripts/poppet/snippet';

const SearchResultSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	className: 'snippet has-info-panel',
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			info      : this.model.get( 'info' ),
			iconClass : this._getIconClass(),
			header    : this.model.get( 'title' ),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	_getIconClass: function () {
		return 'icon icon-material icon-labelled icon-' + this.model.get( 'class' ).toLowerCase();
	},
	
} );

export default SearchResultSnippet;